'use client';

import { token } from '@terra/ui-styled-system';
import type { TerraIcon } from '@terra/ui-icons';
import {
  Alert01Icon,
  CheckmarkCircle02Icon,
  FireIcon,
  SnowIcon,
} from '@terra/ui-icons';
import { Badge, type BadgeProps } from '../badge';

export type BadgeVulnerabilityType = 'Hot' | 'Cold' | 'Safe' | 'Vulnerable';
export type BadgeVulnerabilityProps = Omit<BadgeProps, 'icon'> & {
  type: BadgeVulnerabilityType;
};
type BadgeVulnerabilityConfig = {
  icon: TerraIcon;
  bg: string;
  borderColor: string;
  iconColor: string;
  fg?: string;
};
const BADGE_VULNERABILITY_CONFIG: Record<
  BadgeVulnerabilityType,
  BadgeVulnerabilityConfig
> = {
  Hot: {
    icon: FireIcon,
    bg: token('colors.bg.vulnerability.hot'),
    borderColor: token('colors.border.vulnerability.hot'),
    iconColor: token('colors.fg.vulnerability.hot'),
  },
  Cold: {
    icon: SnowIcon,
    bg: token('colors.bg.vulnerability.cold'),
    borderColor: token('colors.border.vulnerability.cold'),
    iconColor: token('colors.fg.vulnerability.cold'),
  },
  Safe: {
    icon: CheckmarkCircle02Icon,
    bg: token('colors.bg.vulnerability.passed'),
    borderColor: token('colors.border.vulnerability.safe'),
    iconColor: token('colors.fg.vulnerability.passed'),
  },
  Vulnerable: {
    icon: Alert01Icon,
    bg: token('colors.bg.vulnerability.vulnerable'),
    borderColor: token('colors.border.vulnerability.critical'),
    iconColor: token('colors.fg.vulnerability.vulnerable'),
  },
};

export const BadgeVulnerability = ({
  type,
  variant = 'emphasis',
  size = 'md',
  children,
  ...props
}: BadgeVulnerabilityProps) => {
  const config = BADGE_VULNERABILITY_CONFIG[type];
  const VulnerabilityIcon = config.icon;

  return (
    <Badge
      variant={variant}
      size={size}
      bg={config.bg}
      borderColor={config.borderColor}
      color={config.fg}
      icon={<VulnerabilityIcon size={16} color={config.iconColor} />}
      {...props}
    >
      {children}
    </Badge>
  );
};
